module.exports = __webpack_public_path__ + "assets/img/returnBtn-0c661cb3.png";